import React, { useState } from "react";
import ImagePopup from "../../imageComponents/image-popup";
import ScrollToTopOnMount from "../../scrollComponents/ScrollToTopOnRoute";

const AboutUs = () => {
  const [popupOpen, setPopupOpen] = useState(false);

  return (
    <div className="px-6 py-12 max-w-4xl mx-auto text-[#2c7b2f] font-[Lora]">
      <ScrollToTopOnMount />

      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">
        About Us
      </h2>

      <div className="space-y-6">
        <p className="text-base md:text-lg leading-relaxed text-justify">
          Founded by <span className="font-semibold">Siya Xaki and Jan Van Der Merwe</span>, 
          S&J started with a simple mission: to provide professional outdoor services and practical, 
          accredited training programs to communities and individuals.
        </p>

        <p className="text-base md:text-lg leading-relaxed text-justify">
          At S&J, we transform outdoor spaces with expertise and professionalism, offering services like 
          high-risk tree felling, fencing, and firebreaks. Fully B-BBEE certified, we build strong, lasting 
          client relationships through reliable, value-driven services.
        </p>

        <p className="text-base md:text-lg leading-relaxed text-justify">
          Our hands-on AgriSETA-accredited training programs, from chainsaw operation to plant production 
          and high-risk tree climbing, empower individuals with practical skills for a sustainable career.
        </p>

        <p className="text-base md:text-lg leading-relaxed text-justify">
          Our mission is to exceed expectations through quality workmanship and training, and our vision 
          is to be a leading name in outdoor trainings and services, reflecting integrity and professionalism every step of the way.
        </p>

        <p className="text-base md:text-lg leading-relaxed text-justify">
          Over the years, we have grown into a trusted name in outdoor services and agricultural training, 
          committed to sustainable practices and empowering those we serve.
        </p>

        <div className="flex justify-center mt-6">
          <img
            src="/images/about-founders.jpg"
            alt="Founders of S & J Landscaping"
            className="max-w-md w-full rounded-lg cursor-pointer hover:opacity-90 transition-opacity duration-300"
            onClick={() => setPopupOpen(true)}
          />
        </div>
      </div>

      <ImagePopup
        imageSrc={popupOpen ? "/images/about-founders.jpg" : null}
        altText="Founders of S & J Landscaping"
        onClose={() => setPopupOpen(false)}
      />
    </div>
  );
};

export default AboutUs;
